// Saison-Bezeichner: in Firestore-Feldern "2026/27", in Doc-IDs und URLs "2026-27".
// Hier liegen die kleinen Helfer, damit die Umrechnung nicht in jeder Seite
// per replace() nachgebaut wird.

const SPEICHER_KEY = 'letzteSaisonId';

export const saisonIdZuName = (saisonId) => saisonId.replace('-', '/');
export const saisonNameZuId = (saisonName) => saisonName.replace('/', '-');

// Grobe Schätzung der laufenden Saison ohne Firestore-Read: ab September
// zählt das laufende Jahr, davor (Off-Season, Playoffs) das Vorjahr.
export const geschaetzteAktuelleSaisonId = () => {
  const jetzt = new Date();
  const jahr = jetzt.getMonth() + 1 >= 9 ? jetzt.getFullYear() : jetzt.getFullYear() - 1;
  return `${jahr}-${String((jahr + 1) % 100).padStart(2, '0')}`;
};

// Zuletzt besuchte Saison merken, damit die Navigation außerhalb einer
// Saison-Seite (z. B. Hall of Fame) trotzdem ein Ziel für "Tippen" hat.
export const merkeSaisonId = (saisonId) => {
  try {
    localStorage.setItem(SPEICHER_KEY, saisonId);
  } catch (e) {
    // localStorage kann fehlen (privater Modus) – dann eben nicht merken
  }
};

export const letzteSaisonId = () => {
  try {
    return localStorage.getItem(SPEICHER_KEY) || geschaetzteAktuelleSaisonId();
  } catch (e) {
    return geschaetzteAktuelleSaisonId();
  }
};
